import { useEffect, useState } from 'react';
import CheckBox from 'components/shared/CheckBox';
import { useTranslation } from 'react-i18next';

const TYPE_OPTIONS = [
    { key: 'standard', label: 'Standard' },
    { key: 'premium', label: 'Premium' },
    { key: 'ultrapremium', label: 'Ultra Premium' },
];

export default function TypeFilterCheckBoxGroup({ selectedTypes = [], onToggle }) {
    const { t } = useTranslation();

    return (
        <div className="col-2 col-md-9 d-flex justify-content-between justify-content-md-between align-items-center flex-column flex-md-row">
            {TYPE_OPTIONS.map(({ key, label }) => (
                <div key={key} className="col-12 col-md-2 d-flex align-items-center">
                    <div className="label-title me-3 label-choice">{t(label)}</div>
                    <CheckBox
                        name={key}
                        tick={selectedTypes.includes(key)}
                        onCheck={() => onToggle(key)}
                    />
                </div>
            ))}
        </div>
    );
}